<template>
	<t-popover
		:showPopover="popoverIsVisible"
		:marginY="12"
		:marginX="10"
		:style="getStyle"
		direction="bottom"
		:min-width="150"
		relative
	>
		<div slot="target" class="header-select-wrapper">
			<t-panel-header
				:icon="panelHeaderIcon"
				:color="color"
				class="header-select-title"
				size="sm"
				type="bp"
			>
				<slot>{{defaultLabelText}}</slot>
			</t-panel-header>
			<t-icon-button
				type="bp"
				icon="caret-down"
				appearance="transparent"
				iconSize="sm"
				@click="togglePopover"
			/>
		</div>

		<t-menu v-if="items">
			<t-menu-options-group
				:title="title"
				:items="items"
				:selectedItem="selectedItem"
				groupStyle="combobox"
				@change="onChange"
			>
				<template v-slot="slotProps">
					<t-menu-combobox-option-item
						:value="slotProps.item"
						:selected="slotProps.item.id != -1 && slotProps.isSelected"
					>
						<slot name="menuitemlabel" :item="slotProps.item">{{ slotProps.item.label }}</slot>
					</t-menu-combobox-option-item>
				</template>
			</t-menu-options-group>
		</t-menu>
	</t-popover>
</template>

<script>
import formMixin from '../../inputs/formMixin';
import popoverMixin from '../../inputs/popoverMixin';
import TPanelHeader from '../layers/TPanelHeader';
import TIconButton from '../../buttons/TIconButton';
import TPopover from '../../overlays/TPopover';
import {
	TMenu, TMenuOptionsGroup, TMenuComboboxOptionItem
} from '../../menu';
export default {
	name: 'THeaderSelect',
	components: { TPanelHeader, TIconButton, TPopover, TMenu, TMenuOptionsGroup, TMenuComboboxOptionItem },
	mixins: [ formMixin, popoverMixin ],
	props: {
		items: Array,
		title: String,
		selectedItem: Object,
		icon: { type: String, default: 'search' },
		color: { type: String, default: 'blue' },
		defaultLabel: String
	},
	computed: {
		panelHeaderIcon() {
			return this.selectedItem && this.selectedItem.id !== -1 ? 'filter-list' : 'search';
		},
		defaultLabelText() {
			return this.defaultLabel ? this.defaultLabel : this.selectedItem.label;
		}
	},
	methods: {
		onChange(value) {
			this.popoverSetHidden();
			this.$emit('change', value);
		},
		togglePopover() {
			this.popoverToggle();
		},
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';
.header-select-wrapper {
	display: flex;
	align-items: center;
	padding: 0px 15px;
}
.header-select-title {
	flex: 1;
}

</style>

<docs>
```jsx
<t-header-select :items="['Søk etter oppdrag']"/>
```
</docs>
